import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, TextField, Button, Typography, Paper, Alert } from '@mui/material';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import axios from 'axios';
axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL || 'https://social.zherolabs.com';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();
  // Redirect to dashboard if already authenticated
  React.useEffect(() => {
    if (localStorage.getItem('jwtToken')) {
      navigate('/');
    }
  }, [navigate]);

  const handleLogin = async () => {
    setError('');
    if (!email || !password) {
      setError('Please enter both email and password.');
      return;
    }
    if (typeof email !== 'string' || typeof password !== 'string') {
      setError('Invalid input.');
      return;
    }
    console.log('Login:', { email, password });
      try {
        const res = await axios.post('/api/auth/login', { email, password });
      localStorage.setItem('jwtToken', res.data.accessToken);
      // Fetch profile after login (for consistency)
      try {
  const profileRes = await axios.get('/api/auth/profile', {
          headers: { Authorization: `Bearer ${res.data.accessToken}` }
        });
        localStorage.setItem('profile', JSON.stringify(profileRes.data.profile));
      } catch {}
      setSuccess('Logged in!');
      setTimeout(() => {
        // Only redirect if authenticated
        if (localStorage.getItem('jwtToken')) {
          navigate('/');
        } else {
          window.location.reload();
        }
      }, 800);
    } catch (e: any) {
      setError(e.response?.data?.error || 'Login failed');
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'linear-gradient(135deg,#3182ce 0%,#6b46c1 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Paper sx={{ p: 5, borderRadius: 6, boxShadow: 8, minWidth: 380, maxWidth: 420, mx: 'auto', textAlign: 'center', background: 'rgba(255,255,255,0.95)' }}>
        <LockOpenIcon sx={{ fontSize: 48, color: '#3182ce', mb: 2 }} />
        <Typography variant="h3" sx={{ mb: 2, fontWeight: 700, color: '#3182ce', fontFamily: 'Inter, Roboto, Arial' }}>Log In</Typography>
        <Typography sx={{ mb: 3, color: '#6b46c1', fontWeight: 500 }}>Welcome back! Please log in to continue.</Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
        <form onSubmit={e => { e.preventDefault(); handleLogin(); }}>
          <TextField fullWidth label="Email" value={email} onChange={e => setEmail(e.target.value)} sx={{ mb: 2 }} autoComplete="username" />
          <TextField fullWidth label="Password" type="password" value={password} onChange={e => setPassword(e.target.value)} sx={{ mb: 2 }} autoComplete="current-password" />
          <Button type="submit" variant="contained" color="primary" fullWidth sx={{ py: 1.5, fontWeight: 600, fontSize: 18, borderRadius: 3, boxShadow: 2 }}>Log In</Button>
        </form>
  <Button variant="contained" color="secondary" fullWidth sx={{ py: 1.5, fontWeight: 600, fontSize: 18, borderRadius: 3, boxShadow: 2, mt: 2, background: '#ea4335', '&:hover': { background: '#c5221f' } }} onClick={() => window.location.href = 'https://social.zherolabs.com/api/oauth?provider=google'}>
          <img src="https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg" alt="Google" style={{ width: 24, height: 24, verticalAlign: 'middle', marginRight: 8 }} />
          Login with Google
        </Button>
        <Typography sx={{ mt: 3, color: '#3182ce', fontWeight: 500 }}>Don't have an account? <a href="/auth/signup" style={{ color: '#6b46c1', textDecoration: 'underline' }}>Sign Up</a></Typography>
      </Paper>
    </Box>
  );
};

export default Login;
